import { render } from "./TheTip.vue?vue&type=template&id=3a639b55"
import script from "./TheTip.vue?vue&type=script&lang=js"
export * from "./TheTip.vue?vue&type=script&lang=js"

import "./TheTip.vue?vue&type=style&index=0&id=3a639b55&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__